import React, {Component} from 'react';
import {connect} from 'react-redux';
import InputField from "./InputField";
import validate from 'validate.js';
import './index.scss';
import * as azureActions from '../../actions/azure';
// import documentationIcon from "../../assets/img/documentation_icon.png";
import {checkSession} from "../../api/api";
import * as messageConstants from "../../shared/messages";
import {
  ADD_AZURE_AD_CANCELED,
  ANY_ORIGIN,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";

/**
 * AddAzureAD
 */
class AddAzureAD extends Component {
  handleFrameTasks = (e) => {
    console.log(e);
  }
  handleAddAzureAdCanceling = () => {
    // this.props.cancelAddSaml();
    window.parent.postMessage(ADD_AZURE_AD_CANCELED, ANY_ORIGIN);
  }
  handleAddAzureAdSaving = () => {
    const azureData = {
      tenantId: this.state.applicationName,
      appName: this.state.nickname
    }
    //TODO: handle add vs edit
    if (this.props.applicationId) {
      this.props.updateApp(azureData);
    } else {
      this.setState({applicationNameError: "", errorMsg: ""},
          this.props.addAzureAd(azureData))
    }

  }
  handleChangeApplicationName = (e) => {
    this.setState({applicationName: e.target.value, applicationNameError: ""},
        () => this.validateApplicationName());
  }
  handleChangeNickname = (e) => {
    this.setState({nickname: e.target.value, nicknameError: ""},
        () => this.validateNickname());
  }
  validateNickname = () => {
    let errors = validate.single(this.state.nickname, {
          presence: {
            allowEmpty: false,
            message: messageConstants.ERROR_REQUIRED
          }
        },
        {fullMessages: false}
    );

    this.setState({nicknameError: errors});
  }
  validateApplicationName = () => {

    let errors = validate.single(this.state.applicationName,
        {
          presence: {
            allowEmpty: false,
            message: messageConstants.ERROR_REQUIRED
          },
          format: {
            pattern: "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}",
            flags: "i",
            message: messageConstants.ERROR_DIRECTORY_FORMAT
          }
        },
        {fullMessages: false}
    );

    this.setState({applicationNameError: errors});
  }

  constructor(props) {
    super(props);
    this.state = {
      applicationNameError: "",
      nicknameError: "",
      unknownError: ""
    }
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);

      //TODO: uncomment handleEditAzureAD when this component is used for editing. It will load the Tenant info.
      //this.handleEditAzureAD();
    }

  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      if (nextProps.error.status === 409) {
        this.setState(
            {applicationNameError: messageConstants.ERROR_DUPLICATE_DIRECTORY});
      } else if (nextProps.errorMsg !== "") {
        //deeper error here
        this.setState({
          unknownError: nextProps.error.status + " "
          + nextProps.error.statusText
        });
      }
    }
    else {
      this.setState({unknownError: ""});
    }
  }

  render() {
    return (
        <div className="container AddAzureAD-container">
          <div className="row">
            <h1 className="page-title">{messageConstants.AZURE_TITLE_ADD}</h1>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h4 className="sub-title">
                {messageConstants.AZURE_SUB_TITLE}
              </h4>
              {this.state.unknownError === "" ? "" : <h3
                  className="input-error">Error: {this.state.unknownError} </h3>}
              <InputField
                  id="nickname"
                  inputValue={this.state.nickname}
                  onChange={this.handleChangeNickname}
                  placeholder={messageConstants.NICKNAME_PLACEHOLDER}
                  inputName="userFriendlyName"
                  errorText={this.state.nicknameError}
              />
              <InputField
                  id="applicationName"
                  inputValue={this.state.applicationName}
                  onChange={this.handleChangeApplicationName}
                  placeholder={messageConstants.APPLICATION_NAME_PLACEHOLDER}
                  inputName="applicationName"
                  errorText={this.state.applicationNameError}
              />
            </div>
            <div className="col-md-4 col-md-offset-2">
            </div>
          </div>

          <div className="action-row row">
            <div className="col-xs-12">
              <button
                  type="button"
                  className="btn btn-md btn-default"
                  onClick={this.handleAddAzureAdCanceling}
              >
                {messageConstants.CANCEL}
              </button>
              <button
                  type="button"
                  className="btn btn-md btn-primary"
                  onClick={this.handleAddAzureAdSaving}
                  disabled={!((this.state.applicationNameError === ""
                          || this.state.applicationNameError === undefined) &&
                      (this.state.nicknameError === ""
                          || this.state.nicknameError === undefined)
                      && (this.state.nickname !== undefined
                          && this.state.applicationName !== undefined)
                  )}>
                {messageConstants.SAVE_AND_GET_JSON}
              </button>
            </div>
          </div>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    nickname: state.nickname,
    applicationName: state.applicationName,
    error: state.azure.errorMsg
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAzureAd: (formData) => {
      dispatch(azureActions.addAzureAd(formData))
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAzureAD);


// WEBPACK FOOTER //
// ./src/components/AddAzureAD/index.js